// extracted by mini-css-extract-plugin
export default {"container":"Taa-z","oos":"Uaa-z","oosUx":"Vaa-z","selected":"Waa-z","labelOos":"Xaa-z"};